import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import '../styles/SectionConnexion.scss';
import longTrait from '../assets/longTrait.svg'
import { useTranslation } from 'react-i18next';


function GroupingAuth() {
  const { t } = useTranslation();
  return (
    <div className='GroupingConnexion'>
        {<h5>
            <span>{t('auth.confirmCode')}</span>
        </h5>}
        <div>
            <Form className='modal-body-form modal-body-form-auth'>
                <div className='modal-body-form-auth-group'>
                    <Form.Group>
                        <div className='modal-body-form-auth-item'>
                            <span className='modal-body-form-auth-item-blueMagic'></span>
                            <Form.Control type="number"/>
                            <img src={longTrait} alt='long trait'/>
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <div className='modal-body-form-auth-item'>
                            <span className='modal-body-form-auth-item-blueMagic'></span>
                            <Form.Control type="number"/>
                            <img src={longTrait} alt='long trait'/>
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <div className='modal-body-form-auth-item'>
                            <span className='modal-body-form-auth-item-blueMagic'></span>
                            <Form.Control type="number"/>
                            <img src={longTrait} alt='long trait'/>
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <div className='modal-body-form-auth-item'>
                            <span className='modal-body-form-auth-item-blueMagic'></span>
                            <Form.Control type="number"/>
                            <img src={longTrait} alt='long trait'/>
                        </div>
                    </Form.Group>
                </div>
                <div className='queryCodeNumber'>
                    <span className='queryCodeNumber1'>{t('auth.noCodeReceived')} </span>
                    <span className='queryCodeNumber2'>{t('auth.resendCode')}</span>
                </div>
                <Button type="submit" className='btn_inscrip'>{t('auth.confirmCodeBtn')}</Button>
            </Form>
        </div>
    </div>
  )
}

export default GroupingAuth;
